<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a href="">Configuracion</a></li>
        <li>
          <a
            class="link-effect"
            [routerLink]="['/configuracion', 'tipo-visitas']"
            >Tipo Visitas</a
          >
        </li>
        <li><span class="link-effect">Registrar</span></li>
      </ol>
    </div>
  </div>
</div>

<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Registrar Tipo Visita</h3>
    </div>
    <div class="block-content">
      <div class="form-horizontal">
        <form
          #modelForm="ngForm"
          (ngSubmit)="onSubmit(modelForm)"
          appIdentityRevealed
        >
          <div class="form-group">
            <label class="col-md-1 control-label">Tipo Visita:</label>
            <div class="col-md-3">
              <mat-form-field appearance="outline">
                <mat-label>Tipo Visita</mat-label>
                <input
                  matInput
                  type="text"
                  [(ngModel)]="model.nombre"
                  name="nombre"
                  required
                />
              </mat-form-field>
            </div>
          </div>
          <div class="form-group">
            <label class="col-md-1 control-label">Estado:</label>
            <div class="col-md-2">
              <mat-form-field appearance="outline">
                <mat-label> Seleccione: </mat-label>
                <mat-select
                  matSelect
                  [(ngModel)]="model.idEstado"
                  name="idEstado"
                >
                  <mat-option
                    *ngFor="let item of listaEstados; index as i"
                    [value]="item.idParametroDetalle"
                    >{{ item.valor }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-12">
              <button
                type="submit"
                class="btn btn-naranja"
                [disabled]="modelForm.invalid"
                mat-raised-button
              >
                Guardar
              </button>
              <a
                class="btn btn-naranja2"
                mat-raised-button
                [routerLink]="['/configuracion/tipo-visitas']"
                >Cancelar</a
              >
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
